/* en */
module.exports = {
    obj: {
        broswer1: "The browser you are using will cause our platform to load slowly. We recommend using Google Chrome to access the competition.Click here to download Google Chrome.",
        broswer2: "Win32Bit ",
        broswer3: "Win64Bit ",
        broswer4: "Mac",
        title99: "For more information, please contact info@icode.org",
        nav_language: "Switch Language",
        signup_button: "Sign Up",
        homepage_button1: "Sign In",
        homepage_button2: "Sign Up",
        signup_title: "Create An Account",
        signin_title: "Sign In",
        myaccount_button: "Save Info",
        modifyPwd_button: "Modify Pwd",
        releaseNotes: "Release Notes",
        com_cancel: "Cancel",
        com_confirm: "Confirm",
        modifyPsd_1: "Input original password",
        modifyPsd_2: "Input new password and remember Please",
        modifyPsd_3: "Input new password again",
        modify_avator: "Modify Avator",
        modifyPsd_success: "Modify password succeed!",
        modifyPsd_failed: "Modify password failed!",
        modifyPsd_oriPsdError: "Original password is wrong",
        modify_Avator: "Modify Avator",
        modifyAvator_success: "Modify Avator succeed!",
        modifyAvator_failed: "Modify Avator failed!",
        signup_email4: "Don’t see the email in your inbox? The message might be in your Spam or Junk Mail folders so be sure to check there.\n\nIf you do not receive a verification email within one hour, please try the sign-up process again.",
        signup_email2: "Please check your email inbox for an email with a link to verify and activate your account.",
        signup_email3: "Back to Sign In Page",
        signup_email1: "You’re almost done!",
        signin_note3: "Please enter your password",
        signin_note2: "This email address is invalid",
        signin_note1: "Please enter your email",
        signin_note5: "This email address is unregistered",
        signin_note4: "Incorrect password",
        forPass_title: "Forgot Your Password?",
        failWin_txt2: "It looks like QiQi ran out of energy. Please try again.",
        signup_fail1: "/",
        unit8_name: "Green Spaceship Expeditions",
        signup_fail2: "This email has already been registered",
        competition_button: "Start challenge",
        failWin_txt1: "It looks like there is a problem with part of your code. Hint: It's related to QiQi's steps (number and/or direction). Please try again.",
        failWin_txt3: "It looks like QiQi ran out of energy. Make sure to avoid the red energy boosts as they will deplete all of QiQi's energy! Please try again.",
        unit3_name: "Hoverboard Adventures",
        sucPass_title: "Your Password Was Reset Successfully!",
        bindaccountMsg: "The account has been bound with other phone.",
        bindaccountMsgs: "Please bind phone number",
        bindaccountWarn: "After binding mobile phone number can participate in the competition",
        bindaccountWarn1: "Binding failed, the phone has been bound with other account.",

        course_unlocktxt1: "Get",
        course_unlocktxt2: "stars to unlock the next level of training ground",

        signup_note5: "Verification code error",
        signup_note4: "pleasse enter correctly",
        signup_note6: "This email address is invalid",
        signup_note1: "This school code is invalid",
        signup_note3: "Passwords must be identical",
        signup_note2: "Passwords must be 8-16 characters, using only letters and numerals",
        signup_note9: "Please choose...",
        signup_note8: "Please input your name",
        forPass_txt1: "If your account is provided by school, please contact the administrator.",
        forPass_txt3: "Verify",
        forPass_txt2: "Email",
        verifySuc_button: "Enter the Competition",
        signin_button: "Sign In",
        unit7_name: "Challenging Terrain",
        verifyFail_txt: "It looks like you already completed the email verification process.\n\nQuestions? Email info@icode.org",
        signup_txt8: "Please enter your password again",
        signup_txt9: "Phone",
        unit9_name: "Let's Get Energized",
        signup_txt2: "Name",
        signup_txt3: "Grade",
        signup_txt4: "School code",
        signup_txt5: "Enter the school code you received from your teacher",
        signup_txt6: "Password",
        signup_txt7: "Passwords must be 8-16 characters, using only letters and numerals",
        failWin_txt: "It looks like there was a problem with part of your code. Please try again.",
        verifyFail_title: "Oops!",
        verifyWrongemail_txt: "It looks like your verification link is incorrect.\nIf you are unable to click the link in your email, please make sure to copy and paste the link correctly into your web browser.\n\nQuestions? Email info@icode.org",
        unit6_name: "Divide and Conquer",
        failWin_title: "Oops!",
        unit5_name: "Finding Your Path",
        competition_note: "The competition will begin on May 1st! Interested in learning to code? Check out our resources page: \n\n\n\n\n\n\n\n<a target='view_window' href='https://www.icode.org/resources'>https://www.icode.org/resources</a>",
        signup_txt12: "Phone",
        signup_txt13: "Please enter your account",
        signup_txt10: "Verification code",
        signup_txt11: "Send",
        myaccount_txt1: "First Name",
        myaccount_txt2: "Last Name",
        myaccount_txt3: "Grade",
        signin_txt4: "Sign Up",
        signin_txt2: "Set password",
        signin_txt3: "Forgot Your Password?",
        signin_txt1: "Phone",
        signin_txt11: "Account/Phone",
        sucWin_title: "Well done!",
        competition_title: "Competition Leader Board",
        unit2_name: "Spaceship Exploration",
        homepage_title: "Join the Coding Olympics",
        setPass_title: "Re-set Password",
        resetWin_title: "Reset",
        myaccount_title: "My Account",
        emailVerify_txt2: "Questions? Email info@icode.org",
        emailVerify_txt1: "It looks like your verification link is no longer valid. Click here to receive a new verification email.\nRe-send Verification Email",
        language_switch5: "Arabic",
        language_switch4: "Hebrew",
        language_switch3: "Spanish",
        language_switch2: "English",
        language_switch1: "Chinese",
        signup_note15: "Please enter verification code",
        signup_note14: "Please enter your account",
        signup_note17: "Please fill in all required information",
        signup_note16: "Please enter your account",
        signup_note11: "Enter the school code you received from your teacher",
        signup_note10: "Please choose your grade",
        signup_note13: "Please enter your password again",
        signup_note12: "Please enter your password",
        resetWin_txt: "Are you sure you would like to reset the coding area? Any code you edited or added will be deleted.",
        emailVerify_title: "Oops!",
        forPass_win: "Please check your inbox for a link to reset your password",
        nav_setting: "Settings",
        setPass_txt2: "Passwords must be 8-16 characters, using only letters and numerals",
        setPass_txt3: "Please enter your password again",
        setPass_txt1: "Password",
        setPass_txt4: "Submit",
        nav_name: "Coding Olympics",
        emailVerify_button: "Re-send Verification Email",
        emailVerify_note: "Verification Email Has Been Resent Successfully",
        competition_txt1: "Rank",
        competition_txt2: "School",
        competition_txt22: "Student",
        verifyWrongemail_title: "Oops!",
        competition_txt4: "Levels",
        competition_txt44: "My Stars",
        competition_txt5: "School Score",
        competition_txt6: "School Ranking",
        raceGo: "Join Race",

        verifyWrong_title: "Oops!",
        unit4_name: "The Power of Loops",
        competition_txt3: "Points",
        forPass_note2: "This email address is invalid",
        forPass_note3: "Please enter your password",
        forPass_note1: "Please enter your email",
        forPass_note6: "Please enter your password",
        forPass_note7: "This email address is unregistered",
        forPass_note4: "Please enter your password again",
        forPass_note5: "Passwords must be identical",
        sucWin_txt: "Congratulations! You just completed the challenge.",
        setting_1: "My Account",
        setting_2: "Log Out",
        verifyWrong_txt: "It looks like your verification link is incorrect.\nIf you are unable to click the link in your email, please make sure to copy and paste the link correctly into your web browser.\n\nQuestions? Email info@icode.org",
        verifySuc_txt1: "Your account setup is complete and you’re ready to join the competition.",
        sucPass_button: "Back to Homepage",
        myaccount_txt4: "School",
        verifySuc_title: "Awesome!",
        myaccount_txt5: "Email",
        signup_win2: "Please make sure you have your school code and accss to your email inbox in order to complete the account setup process. Don't have a school code? Have your teacher contact us at info@icode.org",
        signup_win1: "Before We Get Started...",
        unit10_name: "Taking Control",
        unit1_name: "First Steps on Mars",
        bad_network: "No Internet Connection",
        competition_txt7: "Top points",
        competition_txt8: "Country",
        grade1: "Grade 1",
        grade2: "Grade 2",
        grade3: "Grade 3",
        grade4: "Grade 4",
        grade5: "Grade 5",
        grade6: "Grade 6",
        grade7: "Grade 7",
        grade8: "Grade 8",
        grade9: "Grade 9",
        grade10: "Grade 10",
        grade11: "Grade 11",
        grade12: "Grade 12",
        competition_nav: "Hi",
        timeout01: "Login expired",
        timeout02: "Session timeout, please login again",
        timeout03: "Re login",
        timeout04: "cancel",
        schoolName: "School Name",
        signin_note50: "The competition will officially start on February 15, 2020. Please stay tuned!",
        myaccountUpdata_title: "Modify information",
        myaccountUpdata_title01: "Welcome to The Second ICode International Youth Coding Competition Preliminary In order to provide you with a better experience, please confirm whether your account information needs to be updated. Once confirmed, it can't be modified again. If you have any questions, you can consult the teacher of ICode: 13162336268",
        badMsg: "Basic user information is valid and cannot be updated again.",
        errmsg: "The competition will officially start on February 15th, 2020. Please stay tuned!",
        score1: "Student Score",
        score2: "School Score",
        score3: "Global",
        score4: "School",
        levelProgress_0: "Blockly",
        levelProgress_1: "Python",
        levelProgress0: "Beginner",
        levelProgress1: "Junior",
        levelProgress2: "Senior",
        levelProgress3: "Intermediate",
        version: "My Version",
        begin: "Beginner",
        modeCode: "Code",
        modeScratch: "Blockly",
        allStars: "Total number of stars",
        allSteps: "Reduced number of moves",
        allLines: "Reduced lines of code",
        bad_errorMsg1: "You can only change to a certified school.",
        bad_errorMsg2: "You've joined a certified school, can't modify it.",
        levelProgressAll: "Total score",
        levelProgressToday: "Best of today",
        notice_lang1: "The Grand Finals of ICode Global Hackathon 2022 is scheduled for December 11, 2022.",
        notice_lang2: "The access to ICode Global Hackathon Platform will be till December 31, 2022.",
        notice_lang3: "If you want to get more learning content, you can become a qualify astronaut and get extra practice levels and monthly competitions(must pass the previous monthly competition).",
        notice_lang4: "The access to ICode Global Hackathon Platform will be till December 31, 2022.",

        notice_isr1: "Welcome to ICode Learning Platform!<br>Here, you can learn programming with great fun!<br>We provide two programming methods: Python and Blockly, for children of different ages to learn.<br>Let's start learning programming now!",
        notice_isr2: "If you want to get more learning content, you can become a qualify astronaut and get extra practice levels and monthly competitions(must pass the previous monthly competition).",
        notice_isr3: "The monthly competition on Level 1 has been upgraded to a weekly competition! You can participate in it at any time. If you get 50 stars in 60 minutes, you will be upgraded to Level 2.",

        myCompetitions: "My Competitions",
        competitionName: "Competition name",
        competitionProgress: "Competition progress",
        notStart: "Not start",
        ongoing: "Ongoing",
        gameover: "Over",
        registrationReview: "Registration is under review",
        registrationFailed: "Registration failed",
        registrationSpproved: "Registration approved",
        notParticipated: "Not participated",
        participated: "Participated",
        myAwards: "My Prize",
        remarks: "Remarks",
        downloadCard: "Download Admission card",
        download: "Other information",
        noData: "No competition data",
        registrateFinal: "Registrate for final",
        myProgress: "My progress",
        myHome: "My home page",
        divisions: "Group",
        stepTips: "The monthly competition will start on June 28",
        index_txt49_noOpen: "This competition is only available for qualify astronauts.",
        index_txt49_lowLevel: "You are not eligible for the competition.",
        finalsTxt: "You can't enter during periods that are not competition time",
        finalsTxt_noOpen: "You cannot join the competition because you are not a finalist",
        gameSettingError: "The competition is not configured, please contact the ICode administrator for info",
        myStars: "Stars",
        MyScore: "My Score",
        Leaderboard: "Leaderboard",

        "pay_txt-0": "Loading...",

        langTitle: "If you are an individual user and want to experience richer learning content, we recommend that you become a personal VIP.<br>Individual VIPs will enjoy the following rights:<br>",
        langTitle_1: "1. Open all paid trainings and get extra 780+ training levels.<br>2. Obtain the qualifications to participate in the 2nd and 3rd promotion competitions and test the level of learning.<br>3. You can watch the video tutorials of difficult levels, and no longer worry about the problems.<br><br>(If you want to experience the ICode course study in depth, please purchase the ICode annual service account from the local ICode competition organizer or designated partner)",

        langTitle2: "If you are from a school or institution, we recommend that you purchase institutional/school VIP accounts for students in bulk.<br><br>The institution/school VIP account will have all the rights of the individual VIP.<br><br>In addition, the institution or school will also have the following rights:",
        langTitle2_1: "1. You can register an account without a mobile phone number to ensure the safety of students' personal information.<br>2. Turn on the teacher and class management functions to understand the class situation and learning progress.<br>3. It has an independent management backstage to facilitate the management of students, teachers and classes.<br>4. Obtain ICode official courseware resources to better carry out teaching activities.<br>5. Get exclusive customer service and give priority to solving usage problems.<br>6. Customize school/institution competitions and expand the influence of schools/institutions.<br>7. Become an ICode partner and share ICode promotional resourcesYour sponsorship helps us provide more learning content, thank you!",

        pay_txt1: "Become VIP",
        pay_txt2: "Personal VIP user rights",
        pay_txt2_1: "Institution/School Rights",

        pay_text_gold_1: "Personal VIP",
        pay_text_gold_2: "30% discount for GOLD",
        pay_text_gold_3: "Time: 2021.05.31-2021.07.15",
        pay_text_gold_4: "￥20.8/month",
        pay_text_gold_5: "Scan with WeChat to buy",

        pay_text_silver_1: "Personal VIP",
        pay_text_silver_2: "20% discount for SILVER",
        pay_text_silver_3: "Time: 2021.05.31-2021.07.15",
        pay_text_silver_4: "￥23.8/month",
        pay_text_silver_5: "Scan with WeChat to buy",

        pay_text_bronze_1: "Personal VIP",
        pay_text_bronze_2: "10% discount for BRONZE",
        pay_text_bronze_3: "Time: 2021.05.31-2021.07.15",
        pay_text_bronze_4: "￥26.8/month",
        pay_text_bronze_5: "Scan with WeChat to buy",

        pay_text3_1: "Personal VIP",
        pay_text3_2: "Suitable for individual users",
        pay_text3_3: "￥29.8/month",
        pay_text3_4: "Scan with WeChat to buy",

        pay_text4_1: "Enterprise Edition",
        pay_text4_2: "For institutions/schools only",
        pay_text4_3: "￥998/user/year",
        pay_text4_4: "Scan for details",

        pay_text10_1: "Scan with WeChat",
        pay_text10_2: "Get more VIP information",

        index_txt0_0: "Blockly: Level ",
        index_txt0_1: "Python: Level ",
        index_txt1: "To upgrade to the Space License: Mars, you need to pass the monthly competition for Earth.",
        index_txt2: "To upgrade to the Space License: Jupiter, you need to pass the monthly competition for Mars.",
        index_txt3: "To upgrade to the Space License: Saturn, you need to pass the monthly competition for Jupiter.",
        index_txt4: "You already have the most advanced license.",
        index_txt5: "Space License: Earth",
        index_txt6: "Space License: Mars",
        index_txt7: "Space License: Jupiter",
        index_txt8: "Space License: Saturn",
        index_txt9: "Trainee astronaut",
        index_txt10: "Qualify astronaut",
        index_txt11: "Become a qualify astronaut",
        index_txt12: "Welcome, qualify astronaut",
        index_txt13: "Python Planet",
        index_txt14: "Blockly Planet",
        index_txt15: "Training course",
        index_txt16: "Welcome to Training ground: Level 1",
        index_txt17: "Welcome to Training ground: Level 2",
        index_txt18: "Welcome to Training ground: Level 3",
        index_txt19: "Welcome to Training ground: Level 4",

        index_txt_level5: "Welcome to Training ground: Level 5",
        index_txt_level6: "Welcome to Training ground: Level 6",

        index_txt20: "Go!",
        index_txt210: "Promotion competition will be reset at next Monday.",
        index_txt211: "Mars competition date: ",
        index_txt212: "Jupiter competition date: ",
        index_txt213: "",
        index_txt22: "Monthly competition",
        jsNotice: "The finals will be held in Shanghai from August 8th to 9th. The finalists can join the competition after entering the exam room and connecting to the room's wifi. If you have any questions, please ask the invigilator for help.",
        jsNoticeDemo: "Start at: August 1, 2020 at 9:30, 14:30 and 19:00.<br/>The simulation finals is only for finalists in China.<br/>The difficulty is not a reference for the finals.<br/>Only for be familiar with the process, no awards.",
        finals_txt1: "2020 ICode Finals (China)",

        index_txt_3x_0: "Requires level ",
        index_txt_3x_1: " pass",

        index_txt34: "Space License: Mars required.",
        index_txt35: "Space License: Jupiter required.",
        index_txt36: "Space License: Saturn required.",
        index_txt37: "You need to be a qualify astronaut before starting this training",
        index_txt38: "Earth Competition in June 2020 (Python)",
        index_txt39: "Earth Competition in June 2020 (Blockly)",
        index_txt40: "Earth Competition in July 2020 (Python)",
        index_txt41: "Earth Competition in July 2020 (Blockly)",
        index_txt42: "Mars Competition in July 2020 (Python)",
        index_txt43: "Mars Competition in July 2020 (Blockly)",
        index_txt44: "Earth Competition in August 2020 (Python)",
        index_txt45: "Earth Competition in August 2020 (Blockly)",
        index_txt46: "Mars Competition in August 2020 (Python)",
        index_txt47: "Mars Competition in August 2020 (Blockly)",
        index_txt470: "Jupiter Competition in August 2020 (Python)",
        index_txt471: "Jupiter Competition in August 2020 (Blockly)",
        index_txt472: "Earth Competition in September 2020 (Python)",
        index_txt473: "Earth Competition in September 2020 (Blockly)",
        index_txt474: "Mars Competition in September 2020 (Python)",
        index_txt475: "Mars Competition in September 2020 (Blockly)",
        index_txt476: "Jupiter Competition in September 2020 (Python)",
        index_txt477: "Jupiter Competition in September 2020 (Blockly)",
        index_txt478: "Saturn Competition in September 2020 (Python)",
        index_txt479: "Saturn Competition in September 2020 (Blockly)",

        game_title_202101: "The 3rd ICode Competition Preliminary (China)",
        game_title_202102: "The 3rd ICode Competition Preliminary (China)",
        game_title_202103: "The 3rd ICode Competition Preliminary (China)",
        game_title_202104: "The 3rd ICode Competition Preliminary (China)",
        game_title_2021301: "The 3rd ICode Competition Final (China)",
        game_title_2021302: "The 3rd ICode Competition Final (China)",
        game_title_2021303: "The 3rd ICode Competition Final (China)",
        game_title_2021304: "The 3rd ICode Competition Final (China)",
        game_title_2021401: "The 3rd ICode Competition Final (China) - Shenzhen",
        game_title_2021402: "The 3rd ICode Competition Final (China) - Shenzhen",
        game_title_2021411: "The 3rd ICode Competition Final (China) - Shenzhen",
        game_title_2021412: "The 3rd ICode Competition Final (China) - Shenzhen",

        game_title_32511: "2021 ICode Nanjing Regional Trial",
        game_title_32501: "2021 ICode Nanjing Regional Trial",

        game_title_201012: "Mars Competition in October 2020 (Python)",
        game_title_201002: "Mars Competition in October 2020 (Blockly)",
        game_title_201112: "Mars Competition in November 2020 (Python)",
        game_title_201102: "Mars Competition in November 2020 (Blockly)",
        game_title_201113: "Jupiter Competition in November 2020 (Python)",
        game_title_201212: "Mars Competition in December 2020 (Python)",
        game_title_201202: "Mars Competition in December 2020 (Blockly)",
        game_title_210112: "Mars Competition in January 2021 (Python)",
        game_title_210102: "Mars Competition in January 2021 (Blockly)",
        game_title_210113: "Jupiter Competition in January 2021 (Python)",
        game_title_210212: "Mars Competition in February 2021 (Python)",
        game_title_210202: "Mars Competition in February 2021 (Blockly)",
        game_title_210312: "Mars Competition in March 2021 (Python)",
        game_title_210302: "Mars Competition in March 2021 (Blockly)",
        game_title_210313: "Jupiter Competition in March 2021 (Python)",
        game_title_210412: "Mars Competition in April 2021 (Python)",
        game_title_210402: "Mars Competition in April 2021 (Blockly)",

        game_title_210512: "Mars Competition in May 2021 (Python)",
        game_title_210502: "Mars Competition in May 2021 (Blockly)",
        game_title_210513: "Jupiter Competition in May 2021 (Python)",

        game_title_210612: "Mars Competition in June 2021 (Python)",
        game_title_210602: "Mars Competition in June 2021 (Blockly)",
        game_title_211612: "Mars Competition in June 2021 (Python)",
        game_title_211602: "Mars Competition in June 2021 (Blockly)",

        game_title_210712: "Level 2 Competition in July 2021 (Python)",
        game_title_210702: "Level 2 Competition in July 2021 (Blockly)",
        game_title_210713: "Level 3 Competition in July 2021 (Python)",
        game_title_210703: "Level 3 Competition in July 2021 (Blockly)",
        game_title_210704: "Level 4 Competition in July 2021 (Blockly)",
        game_title_210705: "Level 5 Competition in July 2021 (Blockly)",

        game_title_210812: "Level 2 Competition in August 2021 (Python)",
        game_title_210802: "Level 2 Competition in August 2021 (Blockly)",
        game_title_210813: "Level 3 Competition in August 2021 (Python)",
        game_title_210803: "Level 3 Competition in August 2021 (Blockly)",
        game_title_210804: "Level 4 Competition in August 2021 (Blockly)",
        game_title_210805: "Level 5 Competition in August 2021 (Blockly)",

        game_title_210912: "Level 2 Competition in September 2021 (Python)",
        game_title_210902: "Level 2 Competition in September 2021 (Blockly)",
        game_title_210913: "Level 3 Competition in September 2021 (Python)",
        game_title_210903: "Level 3 Competition in September 2021 (Blockly)",
        game_title_210904: "Level 4 Competition in September 2021 (Blockly)",
        game_title_210905: "Level 5 Competition in September 2021 (Blockly)",

        index_wxlx32011: "2020 WuXi Competition",
        index_wxlx32012: "2020 WuXi Competition",
        index_wxlx32013: "2020 WuXi Competition",
        index_wxlx32111: "2020 WuXi Finals",
        index_wxlx32112: "2020 WuXi Finals",
        index_wxlx32113: "2020 WuXi Finals",

        index_gd44011: "2020 GuangDong Competition",
        index_gd44012: "2020 GuangDong Competition",
        index_gd44013: "2020 GuangDong Competition",
        index_gd44111: "2020 GuangDong Finals",
        index_gd44112: "2020 GuangDong Finals",
        index_gd44113: "2020 GuangDong Finals",

        index_qszy73001: "QSZY Blockly Competition",
        index_qszy73002: "QSZY Python Competition",

        index_txtA1: "Earth Competition (Blockly)",
        index_txtA2: "Earth Competition (Python)",

        index_txtSwitchToBlocky: "Switch to Blockly",
        index_txtSwitchToPython: "Switch to Python",
        index_txtJoinGame: "Competition",

        index_txt48: "Design Map",
        index_txt49: "The monthly competition has not yet started",
        index_txt50: "The monthly competition will start on the last Saturday night of each month from 19:00 to 20:30.<br/>The first monthly competition will start at 19:00 on June 27, 2020.",
        index_txt51: "National competition",
        index_txt52: "Monthly competition",
        index_txt53: "Earth",
        index_txt54: "Mars",
        index_txt55: "Jupiter",
        index_txt56: "Saturn",

        star_txt1: "Mode",
        star_txt2: "Class",
        star_txt3: "Course",
        star_txt4: "Levels",
        star_txt5: "Activate course",
        star_txt6: "name",
        star_txt7: "Class Dashboard",
        star_txt8: "My Class",
        star_txt9: "Course stars",
        star_txt10: "Levels",
        star_txt11: "Your account expired, please verify it with avaiable phone number.",

        index_course_37011: "Programming Challenge",
        index_course_202107: "org Competition",
        index_course_202109: "Blockly",
        index_course_100120: "Basic(2)",
        index_course_100130: "Basic(3)",
        index_course_100140: "Basic(4)",
        index_course_10010: "Basic(1)",
        index_course_2001: "Basic commands",
        index_course_2002: "Route planning",
        index_course_2003: "Repeat Intro",
        index_course_2004: "Repeat Practice(1)",
        index_course_2005: "Repeat Pattern(1)",
        index_course_2006: "Variable Basic",
        index_course_2007: "Using Variables",
        index_course_2008: "Variable Practice",
        index_course_2009: "Practice Time(1)",
        index_course_2010: "Calculate Vars(1)",
        index_course_2011: "Multiple Vars",
        index_course_2012: "Calculate Vars(2)",
        index_course_2013: "Variable practice(2)",
        index_course_2014: "Repeat Pattern(1)",
        index_course_2015: "maze",
        index_course_2016: "If Intro",
        index_course_2017: "If Practice",
        index_course_2018: "If Else Intro",
        index_course_2019: "Logical operation",
        index_course_2020: "Using If",
        index_course_2021: "If Else Practice",
        index_course_2022: "Practice If",
        index_course_2023: "Sudoku",
        index_course_2024: "Solar Panels",
        index_course_2025: "Nested Repeat(1)",
        index_course_2026: "Nested Repeat(2)",
        index_course_2027: "N-Repeat Practice(1)",
        index_course_2028: "Solar Panels",
        index_course_2029: "Complex N-Repeat",
        index_course_2030: "N-Repeat Practice(2)",
        index_course_2031: "Practice Time",
        index_course_2032: "Multi-branchs(1)",
        index_course_2033: "Multi-branchs(2)",
        index_course_2034: "Function Intro",
        index_course_2035: "Function Practice",
        index_course_2036: "Func with par(1)",
        index_course_2037: "Func with par(2)",
        index_course_2038: "Func with par2(1)",
        index_course_2039: "Func with par2(2)",
        index_course_1001: "Basic(1)",
        index_course_1002: "Creators'",
        index_course_1003: "For loop Practice",
        index_course_1004: "Variable Practice",
        index_course_1005: "Recursion Intro",
        index_course_1006: "Practice of if",
        index_course_1007: "Find patterns(1)",
        index_course_1008: "Variable Practice",
        index_course_1009: "range()",
        index_course_1010: "If & Distance",
        index_course_1012: "Complex variables",
        index_course_1013: "if else",
        index_course_1014: "elif statement",
        index_course_1015: "Find patterns",
        index_course_1016: "Find patterns(2)",
        index_course_1017: "Complex Loop",
        index_course_1018: "Nested repeat(2)",
        index_course_1019: "If block practice",
        index_course_1020: "While statement",
        index_course_1021: "Green Flyers",
        index_course_1022: "Function",
        index_course_1023: "Creators'",
        index_course_1024: "Nested Recursions",
        index_course_1025: "Flyers",
        index_course_1026: "Multi-Recursions",
        index_course_1027: "Green Energy",
        index_course_1028: "Solar Panels",
        index_course_1029: "Solar Panels",
        index_course_1030: "if else",
        index_course_1031: "Guidance",
        index_course_1032: "Basic commands",
        index_course_1033: "Variables in loop",
        index_course_1034: "Nested Loops",
        index_course_1035: "Multiple Variables",
        index_course_1036: "List of Flyers",
        index_course_1037: "List of Items",
        index_course_1038: "Logic operation",
        index_course_1039: "Flyers' movement",
        index_course_1040: "Parameter",
        index_course_1041: "Two recursions",
        index_course_1042: "Dictionary",
        index_course_1043: "Multi-parameters",
        index_course_1044: "Guidance",
        index_course_1045: "Creators'",
        index_course_1046: "Basic commands",
        index_course_1047: "Nested repeat(1)",
        index_course_1048: "Variables",
        index_course_1049: "Logic operation",
        index_course_1050: "Coordinate Intro",
        index_course_10012: "Basic(2)",
        index_course_10013: "Basic(3)",
        index_course_10014: "Basic(4)",
        index_course_1051: "For loop Basic(1)",
        index_course_1052: "For loop Basic(2)",
        index_course_1053: "Repeat",
        index_course_1054: "Repeat Practice(1)",
        index_course_1055: "Variable Intro",
        index_course_1060: "Nested Loops",
        index_course_1061: "Complex N-Repeat",
        index_course_1056: "Conditional",
        index_course_1057: "If block",
        index_course_1058: "Variable Intro",
        index_course_1059: "Nested Practice(1)",

        index_course_2021301: "2021 final b1",
        index_course_2021302: "2021 final b2",
        index_course_2021303: "2021 final p1",
        index_course_2021304: "2021 final p2",

        index_course_6601001: "Halloween!",
        index_course_6601002: "Halloween!",
        index_course_6601003: "Alphabet",
        index_course_6601004: "Alphabet",
        index_course_6601005: "Merry X-mas!",
        index_course_6601006: "Merry X-mas!",
        index_course_6602020: "2020 Memorial",
        index_course_6612020: "2020 Memorial",
        index_course_20011: "Blockly Intro(1)",
        index_course_20012: "Blockly Intro(2)",
        index_course_20013: "Blockly Intro(3)",
        index_course_20014: "Blockly Intro(4)",
        earth_bulletin: "The monthly competition will start on the last Saturday night of each month from 19:00 to 20:30.<br/>The monthly competition in October will start at 19:00 on October 31, 2020.",
        mars_bulletin: "The Mars Competition will start on the last Saturday night of each month for qualify astronaut.<br>Next Competition will start at ",
        jupiter_bulletin: "The Jupiter Competition will start on the last Saturday night of each two months for qualify astronaut.<br>Next Competition will start at ",
        saturn_bulletin: "",
        race_unannounced: "Unannounced",
        race_noaward: "No award",
        gameId_msg_701: "The 2nd ICode Competition Finals (China)",
        gameId_msg_702: "The 2nd ICode Competition Finals (China)",
        gameId_msg_703: "The 2nd ICode Competition Finals (China)",
        gameId_msg_704: "The 2nd ICode Competition Finals (China)",
        gameId_msg_801: "The 2nd ICode Competition Simulation Finals (China)",
        gameId_msg_802: "The 2nd ICode Competition Simulation Finals (China)",
        gameId_msg_803: "The 2nd ICode Competition Simulation Finals (China)",
        gameId_msg_804: "The 2nd ICode Competition Simulation Finals (China)",
        gameId_msg_1: "The 1st ICode Competition Global Preliminary",
        gameId_msg_2: "Olympic programming platform",
        gameId_msg_3: "Israel Olympic Programming Competition",
        gameId_msg_4: "The 2nd ICode Competition Preliminary (China)",
        gameId_msg_5: "The 1st ICode Competition Finals (China)",
        gameId_msg_6: "ICode learning platform",
        prizeId_1: "Gold",
        prizeId_2: "Silver",
        prizeId_3: "Bronze",
        prizeId_4: "Participate",
        prizeId_5: "Best Thinker",
        prizeId_6: "Best Speecher",
        prizeId_7: "Most potential",
        prizeId_8: "Young hacker",
        prizeId_9: "Creative girl",
        prizeId_10: "Creative boy",
        prizeId_11: "Code expert",
        prizeId_12: "ICode Promoter",
        prizeId_13: "Whimsy",
        prizeId_14: "Nice try",
        prizeId_15: "Well done",
        prizeId_16: "Participant",
        prizeId_18: "Promotion",
        time_finals: "Start in ",
        time_finals01: "Competition is over",
        "non-finalist": "Non-finalist",
        no_data_course_txt_0: "The content of this level is under development",
        no_data_course_txt_1: "Stay tuned...",
        enter_tech_btn: "Enter Examine",
        ret_coe_txt_49: "Course Not Open",
        course_explain: "Instruction",
        invite_title: "Invite Member",
        week_game_tips: "This week's qualifying tournament is open.",
        week_game_tips_info: "There is only one chance for promotion once a week.  It should be completed within 60 minutes after the start. Are you sure to start now?",
        week_game_tips_info_txt: "Are you sure?",
        game_title_8001: "2020 ICode Week Competition",
        game_title_8002: "2020 ICode Week Competition",
        game_already_closed: "The competition has already closed",
        week_enter_txt_btn: "Start Competition",
        week_warning_btn_start: "OK",
        week_warning_btn_not_start: "Cancel",
        share_Phone_txt: "Ref Phone",
        ref_phone_txt_tips: "Please enter the correct mobile phone number.",
        enter_tech_study_btn: "Enter Exercise",
        can_not_enter_txt: "Sorry,Your have no permission",

        redeemCode_useBtn: "Use redeem code",

        redeemCode_dialog_title: "Please enter the 16-digit redeem code",
        redeemCode_dialog_input_hint: "Redemption code format: a combination of 16 numbers and letters.",
        redeemCode_usingBtn: "OK",

        // common part
        redeemCode_114_1: "The redeem code you entered has already been used.<br/><br/>If you have any questions, please consult ICode staff.",
        redeemCode_114_2: "Used redeem code",

        redeemCode_115_1: "The redeem code you entered<br/>has expired on <b>",
        redeemCode_115_2: "</b><br/><br/>If you have any questions, please contact ICode staff.",
        redeemCode_115_3: "Expired redeem code",

        redeemCode_116_1: "The redeem code you entered is invalid,<br/>please check and enter again.<br/><br/>If you have any questions, please contact ICode staff.",
        redeemCode_116_2: "Invalid redeem code",

        redeemCode_117_1: "Your qualify astronaut is valid for more than one year,<br/>so the redeem code function is temporarily unavailable.<br/>You can use it after: <b>",
        redeemCode_117_2: "</b><br/>If you have any questions, please contact ICode staff.",
        redeemCode_117_3: "You cannot use the redeem code",

        // checkTicket part
        redeemCode_0_1: "Your redeem code can be redeemed<br/>for qualify astronauts for <b>",
        redeemCode_0_2: "</b> days<br/><br/>The expiration time after redemption is:<br/><b>",
        redeemCode_0_3: "</b><br/><br/>Are you sure to redeem now?",
        redeemCode_0_4: "Are you sure?",

        // useTicket part
        redeemCode_0_5: "Congratulations on becoming a qualify astronaut!<br/><br/>Your expiration time is: <b>",
        redeemCode_0_6: "</b>",
        redeemCode_0_7: "Successful redemption",

        redeemCode_0_checkBtn1: "YES",
        redeemCode_0_checkBtn2: "Not now",
        redeemCode_confirm: "OK",
    },
};



// WEBPACK FOOTER //
// ./src/utils/i18n/en.js